import React from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { WidgetApp } from './WidgetApp';
import type { RuleCMSWidgetEmbedOptions } from './types';

const roots = new WeakMap<Element, Root>();

/**
 * Mount a RuleCMS widget into any DOM element (div, section, …).
 * Re-calling with the same element updates props; use {@link unmount} to tear down.
 */
export function mount(
  element: Element,
  options: RuleCMSWidgetEmbedOptions
): void {
  let root = roots.get(element);
  if (!root) {
    root = createRoot(element);
    roots.set(element, root);
  }
  root.render(
    <WidgetApp
      token={options.token}
      publishedKey={options.publishedKey}
      endpoint={options.endpoint}
    />
  );
}

/** Unmount a previously mounted widget from `element`. */
export function unmount(element: Element): void {
  const root = roots.get(element);
  if (!root) {
    return;
  }
  root.unmount();
  roots.delete(element);
}
